import * as React from 'react';
import _ from 'lodash';
import ContentConstants from '../../../contentConstants';
import { AudienceStatus, DistributionType, IAudience, ISurveyAdminSummary } from '../../../models';
import { defaultAudience } from '../../../store/AudienceDetailsStore';
import { CardLayout, Section, WarningModal } from '../../common';
import { AudienceAdminMenuContent } from './menu/AudienceAdminMenuContent';
import { AudienceMenuSummary } from './menu/AudienceMenuSummary';

export type AdminAudienceMenuProps = {
	isLoadingAudiences: boolean;
	surveyId: number;
	audienceId: number;
	audiences: IAudience[];
	surveyAdminSummary?: ISurveyAdminSummary;
	UpdateAudience: (audience: IAudience, isReopeningSurvey: boolean) => void;
};

export class AdminAudienceMenu extends React.PureComponent<AdminAudienceMenuProps, { openWarningModal: boolean }> {
	constructor(props: AdminAudienceMenuProps) {
		super(props);
		this.state = {
			openWarningModal: false,
		};

		this.handleWarningModalClose = this.handleWarningModalClose.bind(this);
		this.handleWarningModalSubmit = this.handleWarningModalSubmit.bind(this);
		this.handleCancelEventClick = this.handleCancelEventClick.bind(this);
		this.getWarningCancelEventBody = this.getWarningCancelEventBody.bind(this);
		this.showMenuSummary = this.showMenuSummary.bind(this);
	}

	public render() {
		const { isLoadingAudiences, surveyId, audienceId, surveyAdminSummary } = this.props;
		const { openWarningModal } = this.state;
		const showMenuSummary = this.showMenuSummary();

		return (
			<>
				<CardLayout loading={isLoadingAudiences} title={ContentConstants.SURVEY_ADMIN_AUDIENCE_HEADER_CONTROL_PANEL}>
					{surveyAdminSummary && showMenuSummary && <AudienceMenuSummary audienceId={audienceId} />}
					<Section id={'control-panel-actions-section'} sectionHeader={ContentConstants.SURVEY_ADMIN_AUDIENCE_CONTROL_PANEL_ACTIONS}>
						<AudienceAdminMenuContent surveyId={surveyId} audienceId={audienceId} handleCancelEventClick={this.handleCancelEventClick} />
					</Section>
				</CardLayout>
				<WarningModal
					isOpen={openWarningModal}
					onClose={this.handleWarningModalClose}
					onSubmit={this.handleWarningModalSubmit}
					contentHeadline={ContentConstants.WARNING_CANCEL_EVENT_HEADLINE}
					contentBody={this.getWarningCancelEventBody()}
				/>
			</>
		);
	}

	public handleWarningModalSubmit() {
		const { audiences, audienceId } = this.props;
		this.setState({ openWarningModal: false });
		const audience = _.find(audiences, (a) => a.audienceId === audienceId);
		const clonedAudience: IAudience = _.cloneDeep(audience) ?? defaultAudience;

		clonedAudience.audienceStatus = AudienceStatus.Cancelled;
		this.props.UpdateAudience(clonedAudience, false);
	}

	public handleWarningModalClose() {
		this.setState({ openWarningModal: false });
	}

	public handleCancelEventClick() {
		this.setState({ openWarningModal: true });
	}

	public getWarningCancelEventBody() {
		const { audiences, audienceId } = this.props;
		const audienceName = _.find(audiences, (a) => a.audienceId === audienceId)?.audienceName ?? '';
		return ContentConstants.WARNING_CANCEL_EVENT_BODY.replace('{audienceName}', audienceName);
	}

	private showMenuSummary() {
		const { audienceId, audiences } = this.props;
		const audience = _.find(audiences, (a) => a.audienceId === audienceId);
		return (
			audience?.distributionType == DistributionType.SingleLinkWithoutDistribution ||
			audience?.distributionType == DistributionType.SingleLink
		);
	}
}
